// extracted by mini-css-extract-plugin
export default {"status":"LicenseStatus-module_status___7wFO","tooltipTarget":"LicenseStatus-module_tooltipTarget__EtMrC"};